import placementSteps from "./steps";
import placementList from "./placementList";
import placement from "./placement";

export default {
  placementSteps,
  placementList,
  placement
};
